/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getSatisfactionEmailTable = params => {
  return axios.post(`${base}/satisfaction_mail/query`, params)
}
export const getSatisfactionEmailDetail = params => {
  return axios.get(`${base}/satisfaction_mail/get_${params.id}`, {params})
}

export const createSatisfactionEmailData = params => {
  return axios.post(`${base}/satisfaction_mail/create`, params)
}
export const updateSatisfactionEmailData = params => {
  return axios.post(`${base}/satisfaction_mail/edit_${params.id}`, params)
}

export const getSatisfactionEmailLogTable = params => {
  return axios.post(`${base}/satisfaction_mail/query_log_${params.id}`, params)
}
export const getSatisfactionEmailPushLogTable = params => {
  return axios.post(`${base}/satisfaction_mail/query_push_log_${params.id}`, params)
}




// WEBPACK FOOTER //
// ./src/views/satisfaction-email/satisfaction-email.api.js